(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filter2"] && !Shopify.designMode) return;
  try {
    class CollectionTabsScroll {
    constructor(container) {
      this.container = container;
      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;

      this.init();
    }

    init() {
      // Mouse drag scrolling
      this.container.addEventListener('mousedown', (e) => this.handleMouseDown(e));
      this.container.addEventListener('mouseleave', () => this.handleMouseUp());
      this.container.addEventListener('mouseup', () => this.handleMouseUp());
      this.container.addEventListener('mousemove', (e) => this.handleMouseMove(e));

      // Prevent click on drag
      this.container.addEventListener('click', (e) => {
        if (this.hasDragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    handleMouseDown(e) {
      this.isDown = true;
      this.hasDragged = false;
      this.container.classList.add('is-dragging');
      this.startX = e.pageX - this.container.offsetLeft;
      this.scrollLeft = this.container.scrollLeft;
    }

    handleMouseUp() {
      this.isDown = false;
      this.container.classList.remove('is-dragging');
    }

    handleMouseMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - this.container.offsetLeft;
      const walk = (x - this.startX) * 2;
      
      if (Math.abs(walk) > 5) {
        this.hasDragged = true;
      }
      
      this.container.scrollLeft = this.scrollLeft - walk;
    }
  }

  // Initialize all scroll containers
  document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('.collection-tabs-scroll-container');
    containers.forEach(container => new CollectionTabsScroll(container));
  });

  // Reinitialize on Shopify section load (for theme editor)
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const containers = event.target.querySelectorAll('.collection-tabs-scroll-container');
      containers.forEach(container => new CollectionTabsScroll(container));
    });
  }
  } catch(e) { console.error(e); }
})();

})();
